import React,{useState,useEffect} from "react";
import {Button} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DropdownMenu,{TypeItem} from "../core/DropdownMenu";
import {useHistory} from 'react-router-dom';
import { useDispatch,useSelector } from "react-redux";
import {switchApp} from '../store/actions';

const AppSwitcher:React.FC = (props:any)=>{
    
    const dispatch = useDispatch();
    const history = useHistory();

    const appList = useSelector((state:any)=>state.user?state.user.settings.apps:null);
    const currentApp = useSelector((state:any)=>state.currentApp.name);
    const appMenus = useSelector((state:any)=>state.user?state.user.settings.menu:null);

    const [MenuList,setMenuList] = useState<TypeItem[]|[]>();
    
    const [menuEl, setMenuEl] = React.useState<null | HTMLElement>(null);
    const menuOpen = Boolean(menuEl);
    const menuClick = (event: React.MouseEvent<HTMLElement>) => {
        setMenuEl(event.currentTarget);
    };
    const menuClose = () => {
        setMenuEl(null);
    };

    const onItemClick = (item:any)=>{
        let cApp:any = MenuList?.filter((itm)=>{
            return itm.id == item.id;
        });
        if(cApp){
            
            dispatch(switchApp({id:cApp[0].id,name:cApp[0].title}));

            // redirect to first available link
            let currentAppMenu = appMenus.filter((menu:any)=>{
                return menu.app_id == cApp[0].id;
            });
            if(currentAppMenu.length > 0){
                history.push(currentAppMenu[0].path);
            }else{
                history.push('/');
            }
            
        }
    }

    useEffect(()=>{
        if(appList){
            let menuList:TypeItem[] = [];
            appList.forEach((ap,index)=>{
                menuList.push({
                    id:ap.id,
                    title:ap.name,
                    icon:ap.icon,
                    sep: (index<appList.length-1)?true:false
                })
            });
            setMenuList(menuList);
        }
    },[appList])

    return (
        <>
            <Button
              id="demo-customized-button"
              aria-controls="demo-customized-menu"
              aria-haspopup="true"
              aria-expanded={menuOpen ? 'true' : undefined}
              variant="contained"
              disableElevation
              onClick={menuClick}
              endIcon={<KeyboardArrowDownIcon />}
              size="small"
              style={{fontSize:"12px"}}
            >
              Applications 
            </Button>
            {MenuList && MenuList.length?
            <DropdownMenu 
                menuEl={menuEl} 
                menuOpen={menuOpen} 
                onClose={menuClose} 
                onClick={menuClose} 
                menuList={MenuList}
                onItemClick={onItemClick}/>
            :''}
        </>
    );
}

export default AppSwitcher;